import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: " श्री. संतोष शांताराम दुबाका ", designation: "ग्रामपंचायत कापशी ",  imageUrl: "/images/santosh.jpeg" },
  { name: "कु. अर्पणा जयंवंत गहला", designation: "ग्रामपंचायत कापशी",  imageUrl: "/images/arpana.jpeg" },
  { name: "श्रीम. अदिती राजेश सावे", designation: "ग्रामपंचायत कापशी",  imageUrl: "/images/aditi.jpeg" },
  { name: "श्रीम. गीता संतोष गहला", designation: "ग्रामपंचायत कापशी", imageUrl: "/images/gita.jpeg" },
  { name: "श्रीम. प्रियंका प्रकाश महालोडा", designation: "ग्रामपंचायत कापशी",  imageUrl: "/images/priyanka.jpeg" },
  { name: "श्री. उमेश चितामन सुमाडा", designation: "ग्रामपंचायत कापशी",  imageUrl: "/images/umesh.jpeg" },
   
  
  ];

const karmachariMembers = [
 /* { name: "--", designation: " ग्रामपंचायत कर्मचारी ",  imageUrl: "/images/-.jpeg" },
  { name: "--", designation: "रोजगार सेवक कापशी",   imageUrl: "/images/-.jpeg" },
  { name: "-- ", designation: "संगणक प्ररिचालक कापशी",   imageUrl: "/images/-.jpeg" },
  { name: " श्री. ", designation: "सफाई  कर्मचारी", imageUrl: "/images/sharad.jpeg" },
  { name: "श्री.  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/puru.jpeg" },
  { name: "श्री.", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/nikhil.jpeg" },
  { name: "श्री.", designation: "संगणक परिचालक", imageUrl: "/images/pritam.jpeg" },
  { name: "श्री.", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/ajay.jpeg" },*/
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone"> {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">--</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2026 Gram Panchayat — All Rights Reserved.
        
      </div>
    </div>
  );
};

export default GPTeam;
